<template>
    <div class="picker-container">
        <div
            class="picker-column"
            v-for="(column, index) in columns"
            :key="index"
            @touchstart="handleTouchStart($event, index)"
            @touchmove="handleTouchMove($event, index)"
            @touchend="handleTouchEnd($event, index)"
            @mousedown="handleMouseStart($event, index)"
            @mousemove="handleMouseMove($event, index)"
            @mouseup="handleMouseEnd($event, index)"
        >
            <div
                class="picker-list"
                :style="{
          transform: `translateY(${column.offset}px)`,
          transition: column.transition ? 'transform 0.3s' : 'none'
        }"
            >
                <div
                    v-for="(item, i) in column.values"
                    :key="i"
                    class="picker-item"
                    :class="{ 'selected': i === column.activeIndex }"
                >
                    {{ item['name'] }}
                </div>
            </div>
        </div>
        <div class="mask">
            <div class="top"></div>
            <div class="middle"></div>
            <div class="bottom"></div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        columns: {
            type: Array,
            default: () => []
        },
        value: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            startY: 0,
            currentY: 0,
            isTouching: false,
            velocity: 0,
            lastTime: 0,
            lastY: 0,
            oldValue: []
        }
    },

    methods: {
        handleTouchStart(e, index) {
            this.startY = e.touches[0].clientY
            this.currentY = this.startY
            this.isTouching = true
            this.columns[index].transition = false
            this.lastY = e.touches[0].clientY
            this.lastTime = Date.now()
        },

        handleTouchMove(e, index) {
            if (!this.isTouching) return
            const currentY = e.touches[0].clientY
            const deltaY = currentY - this.lastY
            const deltaTime = Date.now() - this.lastTime

            this.velocity = deltaY / (deltaTime || 1) // 防止除零
            this.lastY = currentY
            this.lastTime = Date.now()

            this.updateColumnPosition(index, currentY - this.startY)
        },

        handleTouchEnd(e, index) {
            this.isTouching = false
            this.columns[index].transition = true
            this.adjustPosition(index)
        },

        handleMouseStart(e, index) {
            this.startY = e.clientY
            this.currentY = this.startY
            this.isTouching = true
            this.columns[index].transition = false
            this.lastY = e.clientY
            this.lastTime = Date.now()
        },

        handleMouseMove(e, index) {
            if (!this.isTouching) return
            const currentY = e.clientY
            const deltaY = currentY - this.lastY
            const deltaTime = Date.now() - this.lastTime

            this.velocity = deltaY / (deltaTime || 1)
            this.lastY = currentY
            this.lastTime = Date.now()

            this.updateColumnPosition(index, currentY - this.startY)
        },

        handleMouseEnd(e, index) {
            this.isTouching = false
            this.columns[index].transition = true
            this.adjustPosition(index)
        },

        updateColumnPosition(index, delta) {
            const column = this.columns[index]
            let newOffset = column.offset + delta
            const maxOffset = -(column.values.length - 1) * 36

            // 限制滚动范围
            if (newOffset > 0) newOffset = 0
            if (newOffset < maxOffset) newOffset = maxOffset

            this.startY = this.lastY
            column.offset = newOffset
            this.updateActiveIndex(index)
        },

        adjustPosition(index) {
            const column = this.columns[index]
            const activeIndex = Math.round(-column.offset / 36)
            const maxIndex = column.values.length - 1

            let finalIndex = Math.max(0, Math.min(activeIndex, maxIndex))
            column.offset = -finalIndex * 36
            this.updateActiveIndex(index)
            this.$emit('input', this.getSelectedValues())
        },

        updateActiveIndex(index) {
            this.$emit('change', index);
            const column = this.columns[index]
            const activeIndex = Math.round(-column.offset / 36)
            const maxIndex = column.values.length - 1
            column.activeIndex = Math.max(0, Math.min(activeIndex, maxIndex))
        },

        getSelectedValues() {
            return this.columns.map(column => column.activeIndex)
        }
    }
}
</script>

<style scoped>
.picker-container {
    position: relative;
    height: 252px;
    display: flex;
    background: #fff;
    overflow: hidden;
}

.picker-column {
    flex: 1;
    height: 252px;
    position: relative;
    overflow: hidden;
}

.picker-list {
    position: absolute;
    width: 100%;
    top: 90px;
}

.picker-item {
    height: 36px;
    line-height: 36px;
    text-align: center;
    font-size: 16px;
    color: #666;
    transition: all 0.3s;
}

.picker-item.selected {
    color: #333;
    font-size: 18px;
}

.mask {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.mask > div {
    position: absolute;
    left: 0;
    width: 100%;
    height: 90px;
    background: linear-gradient(
        to bottom,
        rgba(255,255,255,0.95),
        rgba(255,255,255,0.6)
    );
}

.mask .top {
    top: 0;
}

.mask .middle {
    top: 90px;
    height: 36px;
    background: rgba(0,0,0,0.05);
}

.mask .bottom {
    bottom: 0;
    background: linear-gradient(
        to top,
        rgba(255,255,255,0.95),
        rgba(255,255,255,0.6)
    );
}
</style>